import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { FetchPermissionsTemplate, FetchUserPermissionsForCurrentInvestor } from 'api/permission';
import { SET_PERMISSION_TEMPLATE, SET_USER_ACCESS } from 'store/actions';
import { adminPermission, hasPermissionForRoute, isSelectedInvestorGroup } from 'utils/index';

const PermissionsHandler = ({ investor_id, investor_types_data }) => {
    // const investor_types = useSelector((state) => state?.investorDetails?.investor_types);
    const dispatch = useDispatch();
    const [tempPermissionData, setTempPermission] = React.useState(null);
    const location = useLocation();
    const navigate = useNavigate();
    const currentInvestorType = useSelector((state) => state.investorDetails.data)?.investor_type;
    const userPermissions = useSelector((state) => state?.permissions?.userPermissions);

    const {
        data: permissions_template,
        isLoading: isLoadingPermissionsTemplate,
        refetch: refetchPermissionsTemplate
    } = FetchPermissionsTemplate();

    const {
        data: user_access_info,
        isLoading: isLoadingUserAccessInfo,
        refetch: refetchUserAccessInfo
    } = FetchUserPermissionsForCurrentInvestor({ investor_id });

    // Effect to set permissions template and user access info
    useEffect(() => {
        if (!isLoadingPermissionsTemplate && permissions_template) {


            // console.log(permissions_template, "permissions_template_invesstor")
            dispatch({ type: SET_PERMISSION_TEMPLATE, data: permissions_template });

            if (!isLoadingUserAccessInfo && user_access_info) {
                if (investor_types_data && investor_types_data?.length > 0) {
                    const permissionsData = user_access_info?.is_owner
                        ? adminPermission({ permissionsTemplate: permissions_template })
                        : { ...user_access_info.permission };

                    // if (currentInvestorType && isSelectedInvestorGroup({ type: currentInvestorType, investor_types_data })) {
                    //     // delete permissionsData?.startups;
                    //     // console.log(permissionsData, "permissionsData 1")
                    // } else if (currentInvestorType && !isSelectedInvestorGroup({ type: currentInvestorType, investor_types_data })) {
                    //     // delete permissionsData?.startups_new;
                    //     // console.log(permissionsData, "permissionsData 2")
                    // }
                    dispatch({
                        type: SET_USER_ACCESS, permissions: permissionsData, isOwner: user_access_info?.is_owner,
                        userName: user_access_info?.name
                    });
                }
            }
        }
    }, [permissions_template, user_access_info, isLoadingPermissionsTemplate, isLoadingUserAccessInfo, currentInvestorType, investor_types_data]);

    // Effect to check and validate route permissions
    useEffect(() => {
        if (investor_id && userPermissions) {
            // refetchUserAccessInfo().then((response) => {
            if (!hasPermissionForRoute(userPermissions, location.pathname)) {
                navigate('/profile', { replace: true });
            }
            // });
        }
    }, [investor_id, userPermissions, navigate]);

    return null; // Render nothing; this component just handles logic
};

export default PermissionsHandler;
